module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("“All happy families resemble each other, but each unhappy family is unhappy in its own way.”")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EO")]), _vm._v(" T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OLSTOY")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Anna Karenina")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0